import { Tooltip } from '../../../../shared/components/text/tooltip/Tooltip'
import React from 'react'

interface AffiliateCellProps {
  affiliate: string
}

export const AffiliateCell = ({ affiliate }: AffiliateCellProps) => {
  return (
    <Tooltip title={affiliate}>
      <div className='max-w-[250px] truncate'>
        {affiliate || <div className='text-[#6684A7]'>Unspecified</div>}
      </div>
    </Tooltip>
  )
}
